import './bootstrap';
import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    Mousewheel,
    Controller,
    Autoplay,
    Keyboard,
    EffectCreative,
    EffectFade,
    FreeMode,
    Scrollbar,
    Grid,
    EffectCoverflow,
    EffectCards
} from 'swiper/modules';

import intlTelInput from 'intl-tel-input/build/js/intlTelInput.min.js';
window.intlTelInput = intlTelInput;

window._swiper = Swiper;
window._swiperNavigation = Navigation;
window._swiperPagination = Pagination;
window._swiperMousewheel = Mousewheel;
window._swiperController = Controller;
window._swiperAutoplay = Autoplay;
window._swiperKeyboard = Keyboard;
window._swiperCreativeEffect = EffectCreative;
window._swiperEffectFade = EffectFade;
window._swiperFreeMode = FreeMode;
window._swiperScrollbar = Scrollbar;
window._swiperGrid = Grid;
window._swiperCoverFlowEffect = EffectCoverflow;
window._swiperEffectCards = EffectCards;

window.swipers = {};

/**
 * Run Swiper init when the root is near the viewport, then in an idle frame
 * to reduce forced layout during initial load (Lighthouse / web.dev guidance).
 * Do not use for above-the-fold heroes (e.g. home hero); use direct `new _swiper` there.
 *
 * @param {string|Element} selectorOrElement CSS selector or DOM element
 * @param {(root: Element) => void} initCallback receives the resolved element
 */
window.whenSwiperVisible = function (selectorOrElement, initCallback) {
    const el =
        typeof selectorOrElement === 'string'
            ? document.querySelector(selectorOrElement)
            : selectorOrElement;
    if (!el || typeof initCallback !== 'function') {
        return;
    }
    const run = () => {
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(() => initCallback(el), { timeout: 2000 });
        } else {
            window.requestAnimationFrame(() => void setTimeout(() => initCallback(el), 0));
        }
    };
    if (!('IntersectionObserver' in window)) {
        run();
        return;
    }
    const io = new IntersectionObserver(
        (entries, observer) => {
            for (let i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                    observer.disconnect();
                    run();
                    break;
                }
            }
        },
        { rootMargin: '120px', threshold: 0.01 },
    );
    io.observe(el);
};

(function () {
    const header = $('header')[0];
    if (!header) {
        return;
    }
    const doc = document.documentElement;
    const w = window;
    let prevScroll = w.scrollY || doc.scrollTop;
    let curScroll = prevScroll;
    let direction = 0;
    let prevDirection = 0;
    let ticking = false;

    const applyScroll = () => {
        ticking = false;
        curScroll = w.scrollY || doc.scrollTop;
        if (curScroll > prevScroll) {
            direction = 2;
        } else if (curScroll < prevScroll) {
            direction = 1;
        }
        if (direction !== prevDirection) {
            if (direction === 2 && curScroll > 120) {
                header.classList.add('hide');
                prevDirection = direction;
            } else if (direction === 1) {
                header.classList.remove('hide');
                prevDirection = direction;
            }
        }
        prevScroll = curScroll;
    };

    const onScroll = () => {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(applyScroll);
        }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
})();
$(document).ready(function () {
    $('.scrollBtn').on('click', function(e) {
        e.preventDefault();
        $($(this).attr('href'))[0].scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    })
    $('#header-joinus').on('click', function(e) {
        e.preventDefault();
        if($($(this).attr('href')).length > 0)
          $($(this).attr('href'))[0].scrollIntoView({
              behavior: 'smooth',
              block: 'center'
          });
        else
          window.location = $(this).data('svp')
    })
});




